import { DriveStep, startTour, startTourOnFirstVisit } from "./tour";

// Step-by-step overlay for the start page (dashboard). Steps are anchored on
// `data-tour="…"` attributes in Home.tsx and components/home/*; sections that
// aren't shown for this user (no trainings, no rentals, …) are skipped.
const STEPS: DriveStep[] = [
  {
    popover: {
      title: "Willkommen im ClubManager",
      description:
        "Diese kurze Anleitung zeigt, was du auf der Startseite findest.<br/><br/>" +
        "Weitere Bereiche erreichst du über das Menü (☰ oben links).",
    },
  },
  {
    element: '[data-tour="dashboard-messages"]',
    popover: {
      title: "Nachrichten",
      description:
        "Aktuelle Mitteilungen des Vereins an dich – und an deine Kinder (markiert mit „für …“). " +
        "Lange Nachrichten öffnest du mit <b>Mehr anzeigen</b>.",
      side: "bottom",
    },
  },
  {
    element: '[data-tour="dashboard-calendar"]',
    popover: {
      title: "Kalender",
      description:
        "Alle Termine auf einen Blick: <b>Spiele</b> (⚽, H = Heim / A = Auswärts), <b>Trainings</b> und " +
        "<b>Geburtstage</b> (🎂).<br/><br/>" +
        "Fahre mit der Maus über einen Eintrag, um alle Details zu sehen. " +
        "Am Handy wird immer eine Woche angezeigt.",
      side: "bottom",
    },
  },
  {
    element: '[data-tour="dashboard-calendar-nav"]',
    popover: {
      title: "Blättern",
      description: "Mit den Pfeilen wechselst du die Wochen, <b>Heute</b> springt zurück zur aktuellen Woche.",
      side: "bottom",
    },
  },
  {
    element: '[data-tour="dashboard-calendar-filters"]',
    popover: {
      title: "Filter",
      description:
        "Tippe auf eine <b>Mannschaft</b> oder einen <b>Trainings-Tag</b>, um nur diese anzuzeigen. " +
        "Nochmal tippen hebt die Auswahl auf. Die Auswahl bleibt gespeichert und gilt auch für die Statistiken weiter unten.",
      side: "bottom",
    },
  },
  {
    element: '[data-tour="dashboard-my-trainings"]',
    popover: {
      title: "Meine Termine",
      description:
        "Deine nächsten Trainings, Spiele und Veranstaltungen – und die deiner Kinder. Mit <b>Zusagen</b> / <b>Absagen</b> gibst du dem Trainer Bescheid.<br/><br/>" +
        "Wenn mehrere Personen für ein Kind antworten können, gilt die letzte Antwort; darunter steht, wer geantwortet hat.",
      side: "top",
    },
  },
  {
    element: '[data-tour="dashboard-my-rentals"]',
    popover: {
      title: "Meine Ausleihen",
      description:
        "Was du (oder deine Kinder) gerade ausgeliehen oder reserviert habt – z.B. Schlüssel, Dressen oder die Kamera – " +
        "mit dem Rückgabedatum. Überfällige Ausleihen sind rot markiert.",
      side: "top",
    },
  },
  {
    element: '[data-tour="dashboard-leaders"]',
    popover: {
      title: "Statistiken der Saison",
      description:
        "Torschützen, Karten und Eigentore der laufenden Saison. " +
        "Über die Mannschafts-Filter kannst du die Statistik auf einzelne Mannschaften einschränken.",
      side: "top",
    },
  },
  {
    element: '[data-tour="dashboard-help"]',
    popover: {
      title: "Anleitung",
      description: "Diese Anleitung kannst du hier jederzeit wieder starten.",
      side: "bottom",
    },
  },
];

export function startDashboardTour() {
  startTour(STEPS);
}

export function startDashboardTourOnFirstVisit() {
  startTourOnFirstVisit("dashboardTourSeen", STEPS);
}
